import {
  CompassControl,
  KeyboardControl,
  Map,
  Marker,
  MarkerLayer,
  MouseControl,
  ZoomControl,
} from 'react-mapycz';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { TournamentListItemFragment } from '@amf/shared/types/graphql';

import { AppLinks } from 'utils/links';

interface TournamentListMapProps {
  tournaments: TournamentListItemFragment[];
}

function TournamentListMap({ tournaments }: TournamentListMapProps) {
  const { t } = useTranslate('malyfotbal');
  const center: { lat: number; lng: number } = useMemo(() => {
    if (tournaments.length === 0) {
      return { lat: 49.7437572, lng: 15.3386383 };
    }

    let lat = 0.0;
    let lng = 0.0;

    for (const { localityLatitude, localityLongitude } of tournaments) {
      lat += localityLatitude;
      lng += localityLongitude;
    }

    return {
      lat: lat / tournaments.length,
      lng: lng / tournaments.length,
    };
  }, [tournaments]);

  return (
    <Map height='100%' center={center} zoom={8}>
      <KeyboardControl />
      <ZoomControl />
      <MouseControl zoom={true} pan={true} wheel={false} />
      <CompassControl right={10} top={50} />
      {tournaments.map(
        ({ id, name, description, localityLatitude: lat, localityLongitude: lng }) => (
          <MarkerLayer key={id}>
            <Marker
              coords={{ lat, lng }}
              card={{
                header: `<h3>${name}</h3>`,
                body: `<p>${description}</p>`,
                footer: `<div class="TournamentListPage__mapFooter"><a href="${
                  AppLinks.tournamentList
                }/${id}" class="Button Button--blueOutline"><span class="Button__content">${t(
                  'tournaments.list.map.link',
                )}</span></a></div>`,
              }}
            />
          </MarkerLayer>
        ),
      )}
    </Map>
  );
}

export default TournamentListMap;
